import { useEffect, useState } from 'react';

import { HideNotificationActionCreator } from '../../actionCreators';
import './styles.css';

export interface NotificationStateProps {
  message?: string;
}

export interface NotificationDispatchProps {
  hideNotification: HideNotificationActionCreator;
}

type NotificationProps = NotificationStateProps & NotificationDispatchProps;

export default function NotificationComponent(
  props: NotificationProps
): JSX.Element {
  const { hideNotification, message } = props;

  const [state, setState] = useState('');
  useEffect(() => {
    if (message) {
      setState('');
      setTimeout(() => {
        setState('hidden');
        setTimeout(hideNotification, 300);
      }, 2000);
    } else {
      setState('hidden');
    }
  }, [message]);

  return <div className={`notification ${state}`}>{message}</div>;
}
